"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentProduct = exports.sessionStart = void 0;

var _mixpanelBrowser = _interopRequireDefault(require("mixpanel-browser"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var sessionStart = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var getItem,
        setItem,
        currentProduct,
        lastActionTime,
        _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            getItem = _args.length > 0 && _args[0] !== undefined ? _args[0] : localStorage.getItem.bind(localStorage);
            setItem = _args.length > 1 && _args[1] !== undefined ? _args[1] : localStorage.setItem.bind(localStorage);
            currentProduct = _mixpanelBrowser.default.get_property('Current Product');
            lastActionTime = getItem(currentProduct);

            if (!(!lastActionTime || (new Date().getTime() - new Date(lastActionTime).getTime()) / 60000 > _constants.SESSION_TIMEOUT_MINUTES)) {
              _context.next = 8;
              break;
            }

            _context.next = 7;
            return _mixpanelBrowser.default.track('Session Start', {});

          case 7:
            _mixpanelBrowser.default.people.increment('Number of Sessions');

          case 8:
            _mixpanelBrowser.default.register({
              'Last Action': new Date().toISOString()
            });

            setItem(currentProduct, new Date().toString());

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function sessionStart() {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Gets the current prodcuct thats either passed in, or from the current window
 *  location, or from a passed-in url
 * @param {string} [currentProduct] Optional current product
 * @param {string} [url] A url to get the product for instead of the window location
 * @returns {string} The current product
 */


exports.sessionStart = sessionStart;

var getCurrentProduct = function getCurrentProduct(currentProduct, url) {
  var location = url ? new URL(url) : window.location;

  if (currentProduct) {
    // The current product was explicitly passed in through the template tag
    return currentProduct;
  } // otherwise try to figure it out from the window location


  var key = Object.keys(_constants.PRODUCT_MAP).find(function (product) {
    return location.origin.includes(product);
  });

  if (key) {
    return _constants.PRODUCT_MAP[key] === 'Reports' && location.pathname.includes('/trends') ? 'Trends' : _constants.PRODUCT_MAP[key];
  }

  return null;
};

exports.getCurrentProduct = getCurrentProduct;